import { deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../config';
import { cleanupUserData } from './cleanup';
import { validateUserDeletion } from './validation';
import { getUserById } from '../../queries/users';
import type { DeleteUserResult } from './types';

export async function deleteUser(userId: string): Promise<DeleteUserResult> {
  try {
    // Get user data
    const user = await getUserById(userId);
    if (!user) {
      return { success: false, error: 'User not found' };
    }

    // Validate deletion
    const validation = validateUserDeletion(user);
    if (!validation.isValid) {
      return { success: false, error: validation.error };
    }

    // Delete user document
    await deleteDoc(doc(db, 'users', userId));
    
    // Clean up related data
    await cleanupUserData(userId);

    return { success: true };
  } catch (error) {
    console.error('Error deleting user:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Failed to delete user'
    };
  }
}